import React from "react";

import {MuiIcon, MuiIconExternalProps} from "../MuiIcon";

export const H2Icon = React.forwardRef<HTMLElement, MuiIconExternalProps>(
    (props: MuiIconExternalProps, ref) => {
        return (
            <MuiIcon {...props}
                     ref={ref}
            >{'\uf85e'}</MuiIcon>
        );
    })
